<template>
  <div class="mt-4">
    <div v-for="(item, i) in branches" :key="item.id" class="mb-4 path-row">
      <div class="branch-cards-scroll">
        <div v-for="(path, j) in item" :key="path.id" class="branch-card" :class="item.length === 1 ? 'single' : ''">
          <div class="card mb-0">
            <div class="card-header position-relative">
              <h4 class="card-title mb-0">{{ alphabet[i] }}{{ alphabet[j] }}</h4>
              <button v-if="item.length > 0" :aria-label="`remove column ${alphabet[i]}${alphabet[j]}`"
                      class="position-absolute btn-remove-col btn btn-danger btn-sm" type="button"
                      v-on:click="removeCol(i, j)">X
              </button>
            </div>
            <div class="card-body">
              <ChapterSelect :chapters="path.chapters" :uuid="path.id"
                             v-on:addChapter="handleAddChapter($event, path.chapters)"></ChapterSelect>
              <hr/>
              <template v-if="path.chapters.length > 0">
                <ul class="list-group list-group-flush">
                  <li v-for="(chapter, k) in path.chapters" :key="k" class="list-group-item px-0">
                    <div class="d-flex">
                      <div :title="chapter.title" style="width: 90%">
                        {{ chapter.title }}
                        <input :name="`items[${alphabet[i]}${alphabet[j]}${alphabet[k]}][id]`" type="hidden"
                               :value="chapter.chapId">
                      </div>
                      <button aria-label="remove chapter" class="btn btn-default btn-sm" style="width: 10%"
                              type="button"
                              v-on:click="removeChapter(path.chapters, k)">x
                      </button>
                    </div>
                  </li>
                </ul>
              </template>
              <template v-else>
                <div class="alert alert-warning text-center" role="alert">
                  <strong>Path {{ alphabet[i] }}{{ alphabet[j] }} has no scenarios</strong>
                </div>
              </template>
            </div>
            <div v-if="branches[i + 1] && branches[i + 1].length > 1" class="card-footer d-flex justify-content-center">
              <button class="btn btn-link" type="button" v-on:click="showBranchRulesModal(path, i, j)">
                <i class="fas fa-code-branch"></i>
                Edit Branch Rules
              </button>
            </div>
          </div>
        </div>
      </div>
      <button aria-label="add column" class="btn btn-primary position-absolute btn-add-col" type="button"
              v-on:click="addCol(i)">+
      </button>
    </div>
    <button aria-label="add row" class="btn btn-primary" type="button" v-on:click="addRow()">Add Scenario Path</button>
    <input v-model="branchesToString" name="branches" type="hidden">
    <!-- Branch Rules Modal -->
    <div id="modalBranchRules" aria-hidden="true" class="modal fade" role="dialog" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Branch Rules</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">

            <div class="form-group">
              <label for="evaluator-type">Evaluator Type</label>
              <select class="form-control" v-model="currentEvaluatorType" name="evaluator_type" id="evaluator-type">
                <option value="hooks">Hooks</option>
                <option value="meters">Meter Scores</option>
                <option value="ai">AI</option>
              </select>
            </div>

            <div class="tab-content">
              <div id="flow-tab-content" aria-labelledby="flow-tab" class="tab-pane p-2"
                   :class="{ 'active': currentEvaluatorType === 'hooks' }" role="tabpanel">
                <div v-for="(path, k) in branches[currentBranchRuleIndex]" class="card">
                  <div class="card-header">
                    <h4 class="card-title mb-0">
                      <strong>Flow Hook Rules for Path {{ alphabet[currentBranchRuleIndex] }}{{ alphabet[k] }}</strong>
                    </h4>
                  </div>
                  <div class="card-body">
                    <div class="form-group">
                      <input :id="`default-${path.id}-hook`" :value="path.id" class="mr-2" name="hook-default-path"
                             type="radio" :checked="isDefault(path.id)"/>
                      <label :for="`default-${path.id}-hook`">Default Path</label>
                    </div>
                    <div class="form-group">
                      <span class="d-none">{{ currentAvailablePageHooks }}</span>
                      <div v-for="hook in currentAvailablePageHooks">
                        <strong>{{ hook.title }} ({{ hook.pageId }})</strong>
                        <ul class="list-group mb-2">
                          <li v-for="option in hook.flowHooks" class="list-group-item">
                            <input :id="`hook-${option}-${path.id}`" :name="`hook_${path.id}_${hook.flowId}`"
                                   :value="option"
                                   class="mr-2 flow-rule-input"
                                   type="checkbox" :checked="isSelected(option, path.id, hook.flowId)"/>
                            <label :for="`hook-${option}-${path.id}`">{{ option }}</label>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div id="meter-tab-content" aria-labelledby="meter-tab" class="tab-pane p-2"
                   :class="{ 'active': currentEvaluatorType === 'meters' }" role="tabpanel">
                <div v-for="(path, k) in branches[currentBranchRuleIndex]" class="card">
                  <div class="card-header">
                    <h4 class="card-title mb-0">
                      <strong>Meter Rules for Path {{ alphabet[currentBranchRuleIndex] }}{{ alphabet[k] }}</strong>
                    </h4>
                  </div>
                  <div class="card-body">
                    <div class="form-group">
                      <input :id="`default-${path.id}-meter`" :value="path.id" class="mr-2" name="meter-default-path"
                             type="radio" :checked="isDefault(path.id)"/>
                      <label :for="`default-${path.id}-meter`">Default Path</label>
                    </div>
                    <div class="form-group">
                      <span class="d-none">{{ currentAvailablePageHooks }}</span>
                      <div class="d-flex">
                        <div v-for="meter in meters" class="col">
                          <label><strong>{{ meter.label }}</strong></label>
                          <div class="d-flex">
                            <select class="form-control meter-rule-input"
                                    :name="`meter_${path.id}_operator_${meter.id}`"
                                    :value="getMeterRuleValue(path.id, meter.id, 'operator')"
                            >
                              <option value="na">N/A</option>
                              <option value="<">&lt;</option>
                              <option value="<=">&lt;=</option>
                              <option value=">">&gt;</option>
                              <option value=">=">&gt;=</option>
                            </select>
                            <input class="form-control meter-rule-input" type="number"
                                   :name="`meter_${path.id}_value_${meter.id}`"
                                   :value="getMeterRuleValue(path.id, meter.id, 'value')"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div id="ai-tab-content" aria-labelledby="ai-tab" class="tab-pane p-2"
                   :class="{ 'active': currentEvaluatorType === 'ai' }" role="tabpanel">
                <div class="form-group">
                  <label for="ai_model">AI Model</label>
                  <select class="form-control" name="ai_model" id="ai_model" v-model="currentModel">
                    <option value="na">N/A</option>
                    <option v-for="model in models" :value="model">{{ model }}</option>
                  </select>
                </div>
                <div class="form-group">
                  <p><strong>Select Default Path</strong></p>
                  <ul class="list-group">
                    <li v-for="(path, k) in branches[currentBranchRuleIndex]" class="list-group-item">
                      <input :id="`default-${path.id}-ai`" type="radio" name="ai-default-path" :value="path.id"
                             :checked="isDefault(path.id)" class="mr-2"/>
                      <input type="hidden" :name="`default_path_${path.id}`"
                             :value="`Path${alphabet[currentBranchRuleIndex]}${alphabet[k]}_${path.id}`"
                             class="path-mappings"/>
                      <label :for="`default-${path.id}-ai`">
                        <strong>Path{{ alphabet[currentBranchRuleIndex] }}{{ alphabet[k] }}</strong>
                      </label>
                    </li>
                  </ul>
                </div>
                <div class="form-group" v-if="branches[currentBranchRuleIndex]">
                  <label for="ai_prompt" class="">Prompt</label>
                  <textarea class="form-control" name="ai_prompt" id="ai_prompt" cols="30" rows="10"
                            v-model="currentPrompt"></textarea>
                  <p class="small muted mt-1">In your prompt you can instruct the AI to select a path by referring to
                    the paths listed above by name (i.e. PathBA, PathBB, etc.)</p>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" data-dismiss="modal" type="button">Close</button>
            <button class="btn btn-primary" type="button" v-on:click="saveBranchRules(currentPathRuleId)">Save</button>
          </div>
        </div>
      </div>
    </div>
    <!-- End Branch Rules Modal -->
  </div>
</template>

<style scoped>
.btn-remove-col {
  right: 0;
  top: 0;
}

.path-row {
  padding-right: 40px;
  position: relative;
}

.btn-add-col {
  height: 100%;
  right: 0;
  top: 0;
}

.branch-cards-scroll {
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  gap: 1rem;
  padding-bottom: 1rem;
  scrollbar-width: thin;
  scrollbar-color: #ccc #f5f5f5;
  position: relative;
  max-width: 1200px;
}

.branch-card {
  min-width: 350px;
  max-width: 350px;
  flex: 0 0 auto;

  &.single {
    min-width: 100%;
  }
}
</style>

<script setup>
import {computed, onMounted, ref} from 'vue'
import {v4 as uuid4} from 'uuid'
import {cloneDeep} from 'lodash'
import ChapterSelect from "./ChapterSelectComponent.vue"

const props = defineProps({
  branches: {
    type: Array,
    default: () => []
  },
  meters: {
    type: Array,
    default: () => []
  },
  models: {
    type: Array,
    default: () => []
  }
})

const alphabet = ref('ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split(''))
const branches = ref(props.branches || [])
const models = ref(props.models || [])
const meters = ref(props.meters || [])
const defaultCol = ref({id: '', chapters: [], flowRules: {}})
const currentPathIndex = ref(null)
const currentBranchRuleIndex = ref(null)
const currentRulesetIndex = ref(null)
const currentPathRuleId = ref(null)
const currentAvailablePageHooks = ref([])
const currentEvaluatorType = ref('hooks')
const currentPrompt = ref('')
const currentModel = ref('')

const branchesToString = computed(() => JSON.stringify(branches.value))

const buildCol = () => {
  let col = cloneDeep(defaultCol.value)
  col.id = uuid4()
  return col
}

const addCol = (index) => {
  branches.value[index].push(buildCol())
}

const removeCol = (index, j) => {
  branches.value[index].splice(j, 1)
  if (branches.value[index].length === 0) {
    branches.value.splice(index, 1)
  }
}

const addRow = () => {
  branches.value.push([buildCol()])
}

const removeChapter = (chapters, index) => {
  chapters.splice(index, 1)
}

const handleAddChapter = ($event, chapters) => {
  chapters.push({id: uuid4(), chapId: $event.id, title: $event.text})
}

const showBranchRulesModal = async (path, i, j) => {
  currentPathIndex.value = i
  currentPathRuleId.value = path.id
  currentBranchRuleIndex.value = i + 1
  currentRulesetIndex.value = j
  const chapIds = path.chapters.map((item) => item.chapId)
  currentAvailablePageHooks.value = await getPageHooks(chapIds)
  currentEvaluatorType.value = path.evaluatorType
  currentPrompt.value = path.aiRules?.prompt || ''
  currentModel.value = path.aiRules?.model || ''
  $('#modalBranchRules').modal('show')
}

const saveBranchRules = (pathRuleId) => {
  console.log('save to path rule id', pathRuleId)
  // get evaluator type value
  let evaluatorType = document.getElementById('evaluator-type').value
  // get all elements with class flow-rule-input
  let flowInputs = document.getElementsByClassName('flow-rule-input')
  let flowRules = {}
  for (let i = 0; i < flowInputs.length; i++) {
    let keys = flowInputs[i].name.split('_')
    if (!flowRules[keys[1]]) {
      flowRules[keys[1]] = {}
    }
    if (!flowRules[keys[1]][keys[2]]) {
      flowRules[keys[1]][keys[2]] = []
    }
    if (flowInputs[i].type === 'checkbox' && flowInputs[i].checked) {
      flowRules[keys[1]][keys[2]].push(flowInputs[i].value)
    }
  }

  let meterInputs = document.getElementsByClassName('meter-rule-input')
  let meterRules = {}

  // set meter rule values
  for (let i = 0; i < meterInputs.length; i++) {
    let keys = meterInputs[i].name.split('_')
    if (!meterRules[keys[1]]) {
      meterRules[keys[1]] = {}
    }
    if (meterInputs[i].type === 'number') {
      meterRules[keys[1]][keys[3]] = {value: meterInputs[i].value}
    }
  }

  let pathMapInputs = document.getElementsByClassName('path-mappings')
  let pathMapping = {}
  for (let i = 0; i < pathMapInputs.length; i++) {
    let mapping = pathMapInputs[i].value.split('_')
    pathMapping[mapping[0]] = mapping[1]
  }

  let aiRules = {}
  aiRules['prompt'] = currentPrompt.value
  aiRules['model'] = currentModel.value
  aiRules['pathMappings'] = pathMapping

  // set meter rule operators
  for (let i = 0; i < meterInputs.length; i++) {
    let keys = meterInputs[i].name.split('_')
    if (!meterRules[keys[1]]) {
      meterRules[keys[1]] = {}
    }
    if (meterInputs[i].type === 'select-one') {
      meterRules[keys[1]][keys[3]].operator = meterInputs[i].value
    }
  }

  // get value of default-path radio button
  let defaultPath = document.querySelector('input[name="hook-default-path"]:checked')
  if (evaluatorType === 'meters') {
    defaultPath = document.querySelector('input[name="meter-default-path"]:checked')
  } else if (evaluatorType === 'ai') {
    defaultPath = document.querySelector('input[name="ai-default-path"]:checked')
  }

  branches.value.forEach((branch, i) => {
    branch.forEach((path, j) => {
      if (path.id === pathRuleId) {
        path['defaultPathId'] = defaultPath.value
        path['flowRules'] = flowRules
        path['meterRules'] = meterRules
        path['aiRules'] = aiRules
        path['evaluatorType'] = evaluatorType
      }
    })
  })

  currentPathIndex.value = null
  currentPathRuleId.value = null
  currentBranchRuleIndex.value = null
  currentRulesetIndex.value = null
  $('#modalBranchRules').modal('hide')
  console.log(branches.value)
}

const isSelected = (hookId, pathId, pageId) => {
  try {
    if (!branches.value[currentPathIndex.value][currentRulesetIndex.value]['flowRules'][pathId]) {
      return false
    }
    if (branches.value[currentPathIndex.value][currentRulesetIndex.value]['flowRules'][pathId][pageId].length === 0) {
      return false
    }
    return !!branches.value[currentPathIndex.value][currentRulesetIndex.value]['flowRules'][pathId][pageId].includes(hookId);
  } catch (e) {
    console.log(e)
    return false
  }
}

const isDefault = (pathId) => {
  return branches.value[currentPathIndex.value][currentRulesetIndex.value]['defaultPathId'] === pathId
}

const getPageHooks = async (ids) => {
  let hooks = await fetch('/api/chapter/hooks?ids[]=' + ids.join('&ids[]='))
  let resp = await hooks.json()
  return resp
}

const getMeterRuleValue = (pathId, meterId, field) => {
  try {
    const ruleSet = branches.value[currentPathIndex.value][currentRulesetIndex.value];
    if (ruleSet && ruleSet['meterRules'] && ruleSet['meterRules'][pathId] && ruleSet['meterRules'][pathId][meterId]) {
      const value = ruleSet['meterRules'][pathId][meterId][field];
      if (value !== undefined) {
        return value;
      }
    }
  } catch (e) {
    // Log error or handle as needed, but still return default
    console.warn(`Error accessing meter rule value for pathId: ${pathId}, meterId: ${meterId}, field: ${field}`, e);
  }

  if (field === 'operator') {
    return 'na';
  } else if (field === 'value') {
    return '';
  }
  return undefined; // Or some other sensible default
};

onMounted(async () => {
})
</script>
